import request from '@/CommonDP/utils/request';
export default {

  isoManagePageList(params, pageNo, pageSize) {
    return request.post(
      `/isoManage/pageList?pageSize=${pageSize}&pageNum=${pageNo}`,
      params
    );
  }

};
